import React from 'react';
import PropTypes from 'prop-types';
import { map, isEqual, isEmpty } from 'lodash';
import { Row, Col, Button } from 'react-bootstrap';
import uuid from 'uuid/v1';

const NAV_BAR_HEIGHT = 56;
const HEADER_HEIGHT = 85;
const TITLE_HEIGHT = 50;
const BUTTON_HEIGHT = 40;
const MARGIN = 15;
const VERTICAL_HEIGHT =
  NAV_BAR_HEIGHT + TITLE_HEIGHT + 2 * BUTTON_HEIGHT + HEADER_HEIGHT + 2 * MARGIN;

const AtlasStructureStep = ({
  changeEditionStep,
  structures,
  handleSelectedStructure,
  selectedStructure,
  atlasImage,
  atlasType
}) => {
  const dashboard =
    atlasType === 'templateScorecardOneComponent' ||
    atlasType === 'templateScorecardTwoComponents' ||
    atlasType === 'templateScorecardThreeComponents' ||
    atlasType === 'templateScorecardFourComponents' ||
    atlasType === 'templateScorecardFiveComponents' ||
    atlasType === 'templateScorecardSixComponents';

  return (
    <>
      <Row className="m-3 overflow-auto" style={{ height: `calc(100vh - ${VERTICAL_HEIGHT}px)` }}>
        {map(structures, (structure, index) => (
          <React.Fragment key={uuid()}>
            <Col
              className="mb-3"
              xs={12}
              sm={2}
              style={{
                filter: isEqual(structure, selectedStructure)
                  ? 'sepia(100%) hue-rotate(-183deg) saturate(178%)'
                  : ''
              }}
              onClick={() => handleSelectedStructure(structure)}
              onKeyPress={() => {}}
              tabIndex={0}
            >
              <img
                alt="alt"
                width="100%"
                src={`${atlasImage.slice(0, -5)}${dashboard === true ? index + 1 : index}.png`}
                style={{
                  borderRadius: '20%'
                }}
              />
            </Col>
          </React.Fragment>
        ))}
      </Row>
      <Button
        disabled={isEmpty(selectedStructure)}
        variant="success"
        className="float-right"
        onClick={() => changeEditionStep(2)}
      >
        Save
      </Button>
    </>
  );
};

AtlasStructureStep.defaultProps = {
  atlasType: ''
};

AtlasStructureStep.propTypes = {
  changeEditionStep: PropTypes.func.isRequired,
  structures: PropTypes.array.isRequired,
  selectedStructure: PropTypes.array.isRequired,
  handleSelectedStructure: PropTypes.func.isRequired,
  atlasImage: PropTypes.string.isRequired,
  atlasType: PropTypes.string
};

export default AtlasStructureStep;
